import CheckoutScreen from './CheckoutScreen';
import ErrorScreen from './ErrorScreen';
import RestaurantDetailsScreen from './RestaurantDetailsScreen';
import PageNotFound from './PageNotFound';
import OrderDetailsScreen from './OrderDetailsScreen';
import OrderBasketScreen from './OrderBasketScreen';
import RewardDetailsScreen from './RewardDetailsScreen';
import UploadGoogleReviewScreen from './UploadGoogleReviewScreen';

export default {
  CheckoutScreen,
  ErrorScreen,
  RestaurantDetailsScreen,
  PageNotFound,
  OrderDetailsScreen,
  OrderBasketScreen,
  RewardDetailsScreen,
  UploadGoogleReviewScreen,
};
